import { useEffect, useRef } from 'react';

type UnmountCallback = () => void;

export const useOnUnmount = (callback: UnmountCallback) => {
    // Специально не будем завязываться на callback, чтобы функция была вызвана исключительно на unmount

    const unmountCallbackRef = useRef<UnmountCallback>();
    unmountCallbackRef.current = callback;

    useEffect(() => {
        return () => unmountCallbackRef.current?.();
    }, []);
};
